module.exports = __webpack_public_path__ + "static/media/KM.629fc9c1.png";